import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles/index.scss";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import TagManager from "react-gtm-module";
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { googleOAuthClientId, googleTagManagerId } from "./config/config";
import { ConfigProvider } from "antd";

const inputFocusTokens = {
  activeBorderColor: "#1cc0d9",
  activeShadow: "0 0 0 2px rgba(28, 192, 217, 0.16)",
};

const inputFocusTheme = {
  components: {
    Input: inputFocusTokens,
    InputNumber: inputFocusTokens,
    DatePicker: inputFocusTokens,
    Select: {
      colorPrimary: "#1cc0d9",
      controlOutline: "rgba(28, 192, 217, 0.16)",
    },
  },
};

// Initialize Google Tag Manager
const tagManagerArgs = {
  gtmId: googleTagManagerId,
};


TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <GoogleOAuthProvider clientId={googleOAuthClientId}>

    <Provider store={store}>
      <ConfigProvider theme={inputFocusTheme}>
        <App />
      </ConfigProvider>
    </Provider>
    </GoogleOAuthProvider>

    </HelmetProvider>
  // </React.StrictMode>
);
